import { render, staticRenderFns } from "./RoundedCard.vue?vue&type=template&id=1382653e&"
import script from "./RoundedCard.vue?vue&type=script&lang=js&"
export * from "./RoundedCard.vue?vue&type=script&lang=js&"
import style0 from "./RoundedCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports